const mobileMenuDrawer = document.querySelector('.mobile-menu-drawer');
const mobileMenuItems = mobileMenuDrawer.querySelectorAll('[data-has-tier-2]');
mobileMenuItems.forEach((menuItem) => {
  const hasTier2 = menuItem.getAttribute('data-has-tier-2');
  const menuTitle = menuItem.getAttribute('data-mobile-menu-title');
  const tier2Container = mobileMenuDrawer.querySelector(`[data-mobile-tier-2="${menuTitle}"]`);

  if (hasTier2 === 'true') {
    menuItem.addEventListener('click', () => {
      tier2Container.classList.add('active');
      mobileMenuDrawer.style.overflow = 'hidden';
      // Scroll to top of drawer to display full height of tier 2 menu (small devices only)
      mobileMenuDrawer.scrollTop = 0;

      const backButton = tier2Container.querySelector('.menu-drawer-title.tier-2-title');
      backButton.addEventListener('click', () => {
        tier2Container.classList.remove('active');
        mobileMenuDrawer.style.overflow = 'auto';
      });
    });
  }
});
